
import { defineComponent, PropType } from 'vue'
import { TranslationDomainTranslations } from '@/modules/free-forms/types'

export default defineComponent({
    name: 'free-forms-translation-domain-translations-list',
    props: {
        translations: {
            type: Object as PropType<TranslationDomainTranslations[]>,
            required: true
        }
    }
})
